import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    button: 'Contact our team',
    description:
      'In order to validate a company as a beneficial owner, we need to evaluate your situation together.',
    title: 'Please contact us',
  },
  fr: {
    button: 'Contacter notre équipe',
    description:
      'Pour valider une société comme bénéficiaire effectif, nous devons étudier votre situation ensemble.',
    title: 'Contactez-nous',
  },
} as const);
